import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { API_URL } from 'config/app.endpoints';
import useHelmet from 'hooks/useHelmet';

const ProtectedRoute = () => {
  const location = useLocation();
  const csrfToken = Cookies.get('csrftoken');
  const [isAuthenticated, setIsAuthenticated] = React.useState(!!csrfToken);
  const [title, setTitle] = useState('builder');

  const [, updateTitle] = useHelmet();

  useEffect(() => {
    if (location) {
      const locationTitleArray = location.pathname.split('/');
      const locationTitle = locationTitleArray?.pop();
      if (locationTitle && locationTitle !== '') {
        setTitle(locationTitle);
      }
      if (locationTitleArray?.includes('competency')) {
        setTitle('competency');
      }
    }
  }, [location]);

  useEffect(() => {
    const words = title?.split('-');
    const capitalizedTitle = words
      ?.map((word) => word[0].toUpperCase() + word.substring(1))
      .join(' ');
    updateTitle(capitalizedTitle || '');
  }, [title]);

  useEffect(() => {
    setIsAuthenticated(!!csrfToken);
  }, [location.pathname, csrfToken]);

  if (!isAuthenticated) {
    window.location.href = `${API_URL}`;
  }

  return <Outlet />;
};

export default ProtectedRoute;
